(function () {
  function initQuizPopup(popup) {
    if (!popup || popup.dataset.quizInitialized === 'true') return;

    var revealButton = popup.querySelector('[data-quiz-reveal]');
    var promptPanel = popup.querySelector('[data-quiz-prompt]');
    var quizPanel = popup.querySelector('[data-quiz-panel]');
    var iframe = popup.querySelector('[data-quiz-iframe]');

    if (!revealButton || !promptPanel || !quizPanel || !iframe) return;

    popup.dataset.quizInitialized = 'true';

    revealButton.addEventListener('click', function () {
      var iframeSrc = iframe.getAttribute('data-src');

      if (iframeSrc && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframeSrc);
      }

      promptPanel.hidden = true;
      quizPanel.hidden = false;
      popup.classList.add('quiz-popup--quiz-open');

      window.setTimeout(function () {
        var dialog = popup.querySelector('[role="dialog"]');
        if (dialog) dialog.focus();
      }, 100);
    });
  }

  function initAllQuizPopups(container) {
    (container || document).querySelectorAll('[data-quiz-popup]').forEach(initQuizPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllQuizPopups(document);
    });
  } else {
    initAllQuizPopups(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllQuizPopups(event.target);
  });
})();
